import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider, TextField, Grid, Typography, Box, CircularProgress } from "@mui/material"

import { getMfpartyStruct, setData } from './MfpartyStruct'
import { updateTextValue, handleSubmit, updateValue, updateSelectedValue } from '../../core/js/FormUtils'
import { createAPI, updateAPI, getAPI, updateEditableAPI } from './MfpartyAPI';
import { CoreContext } from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { validMobileNumberEntry, validNameEntry, validEmailEntry } from '../../core/js/FormValidation';

import { getPathVariable } from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch, useSelector } from 'react-redux';
import { updateMfpartyObj, addMfpartyObj, setShowEditForMfparty } from 'store/slice/ManufSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';
import { refreshPartyList } from 'store/slice/OrderMgmtSlice';



const indianStates = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
    "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya",
    "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim",
    "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand",
    "West Bengal", "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
];


export default function MfpartyEditFormImpl() {
    const dispatch = useDispatch();
    const { setNotification, lastURL } = React.useContext(CoreContext);
    const [formValues, setFormValues] = useState(getMfpartyStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const { mfpartyDashboard } = useSelector((state) => state.manufslice);
    const [mfpartyId, setMfpartyId] = useState(mfpartyDashboard.selectedId);
    const { businessid } = useSelector((state) => state.headerslice.userprofileInfo)


    const { apiInProgress } = useSelector((state) => state.headerslice)
    useEffect(() => {
    }, [apiInProgress])

    useEffect(() => {
        if (mfpartyId !== -1) {
            if (dataLoaded) return;
            getAPI(mfpartyId, loadForm);
        }
        else {
            // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }

        setFormValues({
            ...formValues,
            ['businessid']: {
                ...formValues['businessid'],
                value: businessid
            }
        })
    }, []);

    const loadForm = (data) => {
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        console.log(value + " == " + getRadioAPIvalue(value))
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value)
            return "yes"
        else
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value === "yes")
            return true
        else
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        updateTextValue(formValues, setFormValues, e);
    }
    const handleDoubleChange = (e) => {
        setShowError(false);
        const parsed = parseFloat(e.target.value);
        if (!isNaN(parsed) && e.target.value == parsed)
            updateTextValue(formValues, setFormValues, e);
    }
    const handleNameChange = (e) => {
        setShowError(false);

        if (validNameEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);

        if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);

        if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }

    const createSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(addMfpartyObj(obj));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(refreshPartyList());
        dispatch(setShowEditForMfparty(false));
    }
    const updateSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(updateMfpartyObj(obj));
        setNotification('Record with id[' + mfpartyId + '] has been updated successfully !!!');
        dispatch(setShowEditForMfparty(false));

    }
    const failuerCallback = (errorMsg) => {
        dispatch(setApiInProgress(false));
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const callCreateAPI = (formValues, successCallBack, failuerCallback) => {
        dispatch(setApiInProgress(true));
        createAPI(formValues, successCallBack, failuerCallback);
    }
    const callUpdateAPI = (id, formValues, updateSuccessCallback, failuerCallback) => {
        dispatch(setApiInProgress(true));
        updateAPI(id, formValues, updateSuccessCallback, failuerCallback);
    }
    const onSubmit = (e) => {
        handleSubmit(e, mfpartyId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, callCreateAPI, callUpdateAPI);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);

        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr = date.getFullYear() + "-" + monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    return (
        <form noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError ? <Alert severity="error">{errorMsg}</Alert> : ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: 440 }}>
                        <Grid container direction="column" padding={1}>
                            <Grid item>
                                <Typography variant='h4'>{mfpartyId === -1 ? 'Add' : 'Edit'} Party </Typography>
                                <Divider />
                            </Grid>
                            <Grid height='25px' ></Grid>
                            {dataLoaded ?
                                <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="center">

                                    <Grid item lg={8} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.title.placeholder}
                                            required={formValues.title.required}
                                            label={formValues.title.label}
                                            name={formValues.title.name}
                                            value={formValues.title.value}
                                            onChange={handleTextChange}
                                            error={formValues.title.error}
                                            helperText={formValues.title.error && formValues.title.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.gst.placeholder}
                                            required={formValues.gst.required}
                                            label={formValues.gst.label}
                                            name={formValues.gst.name}
                                            value={formValues.gst.value}
                                            onChange={handleTextChange}
                                            error={formValues.gst.error}
                                            helperText={formValues.gst.error && formValues.gst.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.mobile.placeholder}
                                            required={formValues.mobile.required}
                                            label={formValues.mobile.label}
                                            name={formValues.mobile.name}
                                            value={formValues.mobile.value}
                                            onChange={handleMobileChange}
                                            error={formValues.mobile.error}
                                            helperText={formValues.mobile.error && formValues.mobile.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item lg={4} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.email.placeholder}
                                            required={formValues.email.required}
                                            label={formValues.email.label}
                                            name={formValues.email.name}
                                            value={formValues.email.value}
                                            onChange={handleEmailidChange}
                                            error={formValues.email.error}
                                            helperText={formValues.email.error && formValues.email.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <RadioForBoolean
                                            label="Supplier"
                                            fieldName={formValues.stocker.name}
                                            defaultValue={getRadioValue(formValues.stocker.value)}
                                            handleChange={handleRadioChange}
                                        />
                                    </Grid>
                                    <Grid item lg={12} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.address.placeholder}
                                            required={formValues.address.required}
                                            label={formValues.address.label}
                                            name={formValues.address.name}
                                            value={formValues.address.value}
                                            onChange={handleTextChange}
                                            error={formValues.address.error}
                                            helperText={formValues.address.error && formValues.address.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item lg={4} xs={6}>
                                        <TextField size="Normal"
                                            placeholder={formValues.city.placeholder}
                                            required={formValues.city.required}
                                            label={formValues.city.label}
                                            name={formValues.city.name}
                                            value={formValues.city.value}
                                            onChange={handleTextChange}
                                            error={formValues.city.error}
                                            helperText={formValues.city.error && formValues.city.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={6}>
                                        <TextField size="Normal"
                                            placeholder={formValues.pincode.placeholder}
                                            required={formValues.pincode.required}
                                            label={formValues.pincode.label}
                                            name={formValues.pincode.name}
                                            value={formValues.pincode.value}
                                            onChange={handleTextChange}
                                            error={formValues.pincode.error}
                                            helperText={formValues.pincode.error && formValues.pincode.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12}>
                                        <FormControl fullWidth required={formValues.state.required} error={formValues.state.error}>
                                            <InputLabel id="state-select-label">{formValues.state.label}</InputLabel>
                                            <Select
                                                labelId="state-select-label"
                                                id="state-select"
                                                name={formValues.state.name}
                                                value={formValues.state.value}
                                                label={formValues.state.label}
                                                onChange={handleTextChange}
                                            >
                                                {indianStates.map((stateName) => (
                                                    <MenuItem key={stateName} value={stateName}>
                                                        {stateName}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {formValues.state.error && (
                                                <Typography variant="caption" color="error">
                                                    {formValues.state.errorMessage}
                                                </Typography>
                                            )}
                                        </FormControl>
                                    </Grid>





                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.businessid.placeholder}
                                            required={formValues.businessid.required}
                                            label={formValues.businessid.label}
                                            name={formValues.businessid.name}
                                            value={formValues.businessid.value}
                                            onChange={handleTextChange}
                                            error={formValues.businessid.error}
                                            helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                            sx={{ width: '100%', }}
                                        />
                                    </Grid>
                                </Grid>
                                : <></>}
                        </Grid>
                    </Grid>
                </Box>
                <Grid height='25px' ></Grid>
                <Grid padding={1}>
                    <Divider />
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                    {apiInProgress ? <CircularProgress /> :
                        <>
                            <Button variant="outlined" type="submit" >{mfpartyId === -1 ? 'Add' : 'Save'}</Button>&nbsp;&nbsp;&nbsp;
                            <Button variant="outlined" onClick={() => { dispatch(setShowEditForMfparty(false)); }}>Close</Button>
                        </>
                    }
                </Grid>
            </Grid>
        </form>
    );
};